import type {
  ImportAutoConfiguratorDataRequestParams,
  ImportAutoConfiguratorDataResponse,
} from '@snap-types/actions/import-auto-configurator-data';
import { AUTO_CONFIGURATOR_SLICE_NAME } from '@ui/constants/auto-configurator';
import { buildSiteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

type ImportAutoConfiguratorDataMutationInput = {
  params: ImportAutoConfiguratorDataRequestParams;
  body: FormData;
};

const [_, useImportAutoConfiguratorDataMutation] = injectMutation<
  ImportAutoConfiguratorDataMutationInput,
  ImportAutoConfiguratorDataResponse
>(
  `${AUTO_CONFIGURATOR_SLICE_NAME}/importAutoConfiguratorData`,
  ({ params, body }) => ({
    url: buildSiteUrl(params.siteCode, 'auto-configurator/import-datasets'),
    method: 'POST',
    body,
  }),
);

export { useImportAutoConfiguratorDataMutation };
